import { render, staticRenderFns } from "./DeviceQuestions.vue?vue&type=template&id=9bb3e544&"
import script from "./DeviceQuestions.vue?vue&type=script&lang=js&"
export * from "./DeviceQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports